import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homethirteen-about',
  templateUrl: './homethirteen-about.component.html',
  styleUrls: ['./homethirteen-about.component.scss']
})
export class HomethirteenAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
